import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { fetchAlerts, resetErrorMessage, setAlertFetchFailure, setAlertFetchSuccess, } from 'AlertsApp/ts/features/alerts-modals/state/alert-modal-status/alert-modal-status.actions';
import { setAlertObject } from 'AlertsApp/ts/features/alerts-modals/state/alert-object/alert-object.actions';
import { ALERTS_MODAL_STATE_SLICE_KEY } from 'AlertsApp/ts/features/alerts-modals/state/alerts-modal.reducer';
import { getAlertModalStatus, getAlertObject, getMetricAlerts, getSystemAlerts, } from 'AlertsApp/ts/features/alerts-modals/state/alerts-modal.selectors';
import { METRIC_AND_SYSTEM_ALERT_SUPPORTED_OBJECTS } from 'AlertsApp/ts/features/alerts-modals/constants';
import { ALERTS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { INDICATOR, INDICATOR_WATCHLIST } from 'NewAngular/constants/core.constants';
import { AlertsService } from 'AlertsApp/ts/services/alerts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { IndicatorAlertParamsComponent } from 'AlertsApp/ts/features/alerts-modals/components/indicator-alert-params/indicator-alert-params.component';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "AlertsApp/ts/services/alerts.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@ngrx/store";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i8 from "AlertsApp/ts/features/alerts-modals/components/alert-params/alert-params.component";
import * as i9 from "AlertsApp/ts/features/alerts-modals/components/indicator-alert-params/indicator-alert-params.component";
import * as i10 from "AlertsApp/ts/features/alerts-modals/components/metric-alerts-list/metric-alerts-list.component";
import * as i11 from "AlertsApp/ts/features/alerts-modals/components/system-alerts-list/system-alerts-list.component";
function MetricAndSystemAlertsModalComponent_div_1_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MetricAndSystemAlertsModalComponent_div_1_div_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "Create a New Alert");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "ycn-indicator-alert-params", 16, 2);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("alertObject", ctx_r1.alertObject);
} }
function MetricAndSystemAlertsModalComponent_div_1_div_1_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "Create a New Metric Alert");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "ycn-alert-params", 17);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("alertObject", ctx_r1.alertObject)("defaultOnly", ctx_r1.defaultOnly);
} }
function MetricAndSystemAlertsModalComponent_div_1_div_1_ycn_metric_alerts_list_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-metric-alerts-list", 18);
    i0.ɵɵlistener("sharingCallback", function MetricAndSystemAlertsModalComponent_div_1_div_1_ycn_metric_alerts_list_9_Template_ycn_metric_alerts_list_sharingCallback_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.fetchAlerts(ctx_r1.alertObject)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("alertObject", ctx_r1.alertObject);
} }
function MetricAndSystemAlertsModalComponent_div_1_div_1_ycn_system_alerts_list_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-system-alerts-list");
} }
function MetricAndSystemAlertsModalComponent_div_1_div_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function MetricAndSystemAlertsModalComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ycn-simple-modal-header", 7);
    i0.ɵɵlistener("closeModalHandler", function MetricAndSystemAlertsModalComponent_div_1_div_1_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 8)(3, "div", 9);
    i0.ɵɵtemplate(4, MetricAndSystemAlertsModalComponent_div_1_div_1_ng_container_4_Template, 1, 0, "ng-container", 10)(5, MetricAndSystemAlertsModalComponent_div_1_div_1_ng_template_5_Template, 4, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(7, MetricAndSystemAlertsModalComponent_div_1_div_1_ng_template_7_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MetricAndSystemAlertsModalComponent_div_1_div_1_ycn_metric_alerts_list_9_Template, 1, 1, "ycn-metric-alerts-list", 11)(10, MetricAndSystemAlertsModalComponent_div_1_div_1_ycn_system_alerts_list_10_Template, 1, 0, "ycn-system-alerts-list", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵtemplate(12, MetricAndSystemAlertsModalComponent_div_1_div_1_div_12_Template, 1, 1, "div", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const indicatorAlertParams_r4 = i0.ɵɵreference(6);
    const metricAlertParams_r5 = i0.ɵɵreference(8);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("header", "Alerts for " + ctx_r1.alertObject.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.objectIsIndicator)("ngIfThen", indicatorAlertParams_r4)("ngIfElse", metricAlertParams_r5);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.metricAlerts.length > 0 && ctx_r1.alertObject);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.objectIsIndicator);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
} }
function MetricAndSystemAlertsModalComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 8)(2, "div", 20)(3, "div", 21)(4, "div", 22);
    i0.ɵɵtext(5, "Loading Alerts...");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 23);
    i0.ɵɵelementEnd()()()();
} }
function MetricAndSystemAlertsModalComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ycn-simple-modal-header", 7);
    i0.ɵɵlistener("closeModalHandler", function MetricAndSystemAlertsModalComponent_div_1_div_3_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 8)(3, "div", 9)(4, "div", 24);
    i0.ɵɵtext(5, " Alerts failed to load. Please refresh the page or contact support. ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 13);
    i0.ɵɵelement(7, "div", 25);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("header", "Alerts for " + ctx_r1.alertObject.name);
} }
function MetricAndSystemAlertsModalComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, MetricAndSystemAlertsModalComponent_div_1_div_1_Template, 13, 7, "div", 6)(2, MetricAndSystemAlertsModalComponent_div_1_div_2_Template, 7, 0, "div", 6)(3, MetricAndSystemAlertsModalComponent_div_1_div_3_Template, 8, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r1.alertModalStatus.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "pending");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "error");
} }
/**
 * MetricAndSystemAlertsModalComponent - used for security and watchlist alert objects.
 *
 * Modal base for three modals that show up depending on the status: success, pending or error. For a successful
 * alert list fetch, the main modal will show three sections to register a new alert, show the list of metric alerts,
 * and the available system alerts.
 *
 * Output Properties:
 *  newAlertGroupHandler: Emits when the modal closes and alerts have been created for an alert object that had no alerts.
 *  deleteAlertGroupHandler: Emits when the modal closes and all existing alerts for the alert object have been deleted.
 */
export class MetricAndSystemAlertsModalComponent {
    constructor(alertsService, featureService, store) {
        this.alertsService = alertsService;
        this.featureService = featureService;
        this.store = store;
        this.newAlertGroupHandler = new EventEmitter();
        this.deleteAlertGroupHandler = new EventEmitter();
        // Data & flags
        this.isOpen = false;
        this.initialAlerts = [];
        this.metricAlerts = [];
        this.systemAlerts = [];
        this.objectIsIndicator = false;
        this.defaultOnly = false;
        this.mapStateToComponent = (state) => {
            const alertObject = getAlertObject(state);
            this.setAlertObjectAndGetAlerts(alertObject);
            this.isOpen = this.alertObject !== undefined && this.isSupportedAlertObject(alertObject);
            this.systemAlerts = getSystemAlerts(state);
            this.metricAlerts = getMetricAlerts(state);
            this.alertModalStatus = getAlertModalStatus(state);
            this.errorMessage = this.alertModalStatus.errorMessage;
        };
        this.storeSubscription = store.select(ALERTS_MODAL_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    /**
     * Closes modal handler. Resets the error message and alert object.
     */
    closeModal() {
        this.resetErrorMessage();
        const alertObjectHasAlerts = this.hasAlerts();
        if (alertObjectHasAlerts && this.initialAlerts.length === 0) {
            // if no alerts existed, and alerts were created in the modal
            this.newAlertGroupHandler.emit();
        }
        else if (!alertObjectHasAlerts && this.initialAlerts.length !== 0) {
            // if all existing alerts have been deleted
            this.deleteAlertGroupHandler.emit(this.alertObject);
        }
        this.initialAlerts = [];
        this.store.dispatch(setAlertObject({ alertObject: undefined }));
    }
    /**
     * Gets the registered alerts for the user and the object, then dispatches `setAlertFetchSuccess` to set the
     * alerts in the state. Sets `this.alertObject` with the new value.
     *
     * @param alertObject: Object from where the service will fetch alerts info.
     */
    setAlertObjectAndGetAlerts(alertObject) {
        if (alertObject && this.isSupportedAlertObject(alertObject) && !this.isOpen) {
            this.resetErrorMessage();
            // Fetch alerts the first time the modal opens.
            this.store.dispatch(fetchAlerts());
            this.fetchAlerts(alertObject, true);
            this.objectIsIndicator = alertObject.type === INDICATOR || alertObject.type === INDICATOR_WATCHLIST;
        }
        this.alertObject = alertObject;
    }
    /**
     * Gets the registered alerts for the user and the object, then dispatches `setAlertFetchSuccess` to set the
     * alerts in the state.
     *
     * @param alertObject: The underlying object to fetch alerts for.
     */
    fetchAlerts(alertObject, firstFetch = false) {
        this.alertsService.getAlertsForObject(alertObject.type, alertObject.id).subscribe({
            next: (alerts) => {
                if (firstFetch) {
                    this.initialAlerts = alerts;
                }
                this.store.dispatch(setAlertFetchSuccess({ alertObject, alerts }));
            },
            error: () => {
                this.store.dispatch(setAlertFetchFailure({
                    errorMessage: 'Error fetching alerts. Please refresh the page or contact support.',
                }));
            },
        });
    }
    /**
     * Dispatches `resetErrorMessage` to reset the error message in the state.
     */
    resetErrorMessage() {
        this.store.dispatch(resetErrorMessage());
    }
    /**
     * Checks that the user has the alerts feature enabled and then opens the alerts modal
     * for the given alertObject.
     *
     * @param alertObject: Security or Watchlist to be set for the alerts modal.
     */
    openModal(alertObject) {
        if (this.featureService.userHasFeatures([ALERTS_FEATURE])) {
            this.store.dispatch(setAlertObject({
                alertObject,
            }));
        }
        else {
            this.featureNeededComponent.openModal(ALERTS_FEATURE);
        }
    }
    /**
     * Returns true if this modal supports the given alert object type - this modal
     * supports security and watchlist types.
     *
     * @param alertObject AlertObject the alert object to type check
     */
    isSupportedAlertObject(alertObject) {
        if (alertObject) {
            return METRIC_AND_SYSTEM_ALERT_SUPPORTED_OBJECTS.has(alertObject.type);
        }
        return false;
    }
    /**
     * Returns true if the alert object has metric or system alerts, else false.
     **/
    hasAlerts() {
        return this.metricAlerts.length !== 0 || this.systemAlerts.length !== 0;
    }
}
MetricAndSystemAlertsModalComponent.ɵfac = function MetricAndSystemAlertsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MetricAndSystemAlertsModalComponent)(i0.ɵɵdirectiveInject(i1.AlertsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.Store)); };
MetricAndSystemAlertsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MetricAndSystemAlertsModalComponent, selectors: [["ycn-metric-and-system-alerts-modal"]], viewQuery: function MetricAndSystemAlertsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
        i0.ɵɵviewQuery(IndicatorAlertParamsComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.indicatorAlertParamsComponent = _t.first);
    } }, inputs: { defaultOnly: "defaultOnly" }, outputs: { newAlertGroupHandler: "newAlertGroupHandler", deleteAlertGroupHandler: "deleteAlertGroupHandler" }, standalone: false, decls: 3, vars: 2, consts: [["indicatorAlertParams", ""], ["metricAlertParams", ""], ["indicatorAlertParamsComponent", ""], [3, "closeModalHandler", "open"], [3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "notes-section"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "alertObject", "sharingCallback", 4, "ngIf"], [4, "ngIf"], [1, "modal-footer"], ["class", "text-red", 3, "textContent", 4, "ngIf"], [1, "modal-section-title"], [3, "alertObject"], [3, "alertObject", "defaultOnly"], [3, "sharingCallback", "alertObject"], [1, "text-red", 3, "textContent"], [1, "modal-section"], [1, "loader"], [1, "loader-message"], [1, "loader-spinner"], [1, "text-red"], [1, "modal-footer-actions"]], template: function MetricAndSystemAlertsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 3);
        i0.ɵɵlistener("closeModalHandler", function MetricAndSystemAlertsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵtemplate(1, MetricAndSystemAlertsModalComponent_div_1_Template, 4, 4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.alertObject && ctx.alertModalStatus);
    } }, dependencies: [i4.NgIf, i4.NgSwitch, i4.NgSwitchCase, i5.FeatureNeededComponent, i6.ModalBaseComponent, i7.SimpleModalHeaderComponent, i8.AlertParamsComponent, i9.IndicatorAlertParamsComponent, i10.MetricAlertsListComponent, i11.SystemAlertsListComponent], encapsulation: 2 });
